export default __webpack_public_path__ + "static/media/3.c347fe59.jpg";